<!-- TODO 输入参数，调整尺寸 -->
<template>
    <div style="display:flex; align-items:center; justify-content: center">
        <!-- Emoji 区域 -->
        <div style="cursor:pointer; margin-right: 3px">
            <el-popover
                placement="top-start"
                width="300"
                trigger="click">
                <div class="emoji-wrapper">
                    <b @click="setEmoji(id)" v-for="(item, id) in emojis" :key="id" class="emoji-item">{{item}}</b>
                </div>
                <iconfont-selector :is-actived="false"
                                   :font-size="28"
                                   :font-weight="600"
                                   :line-height="40"
                                   default-class="iconfont icon-sy-emoji1"
                                   default-color="#2c3e50"
                                   actived-class="iconfont icon-sy-emoji1"
                                   actived-color="#2c3e50"
                                   slot="reference" >
                </iconfont-selector>
            </el-popover>
        </div>
        <!-- 评论输入区域 -->
        <el-input
            ref="textarea"
            type="textarea"
            placeholder="请输入内容"
            v-model="textarea"
            id="myinput"
            maxlength="100"
            show-word-limit
            :rows="1"
            size="medium"
            resize="none"
            class="needsclick"
            @input="handleInput"></el-input>
        <!-- 评论提交区域 -->
        <div style="width:50px">
            <el-link v-bind:disabled="disableCommit" :underline="false" @click="submit">发布</el-link>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {CachedApiSecurity} from "../../api-security";
    import {getCachedUser, loadingInstance, errorMessage} from "../../utils";
    import {saveComment} from "../../data/comment";
    import Vue from "vue";
    // 可以准确的将 Emoji 插入 Text Area 的光标位置，甚至于可以记住上一次离开 TextArea 的焦点位置，并准确将 Emoji 插入该位置中。
    // TODO 搞懂其中的原理部分
    const changeSelectedText = (textArea, str) => {
        if (window.getSelection) {
            // 非 IE 浏览器
            textArea.setRangeText(str);
            // 在未选中文本的情况下，重新设置光标位置
            textArea.selectionStart += str.length;
            textArea.focus();
        } else if (document.selection) {
            // IE 浏览器
            textArea.focus();
            var sel = document.selection.createRange();
            sel.text = str;
        }
        return textArea.value;
    };

    export default {
        name: "Input",
        props: {
            updateComments: Function
        },
        data(){
            return {
                // 输入框需要的 data 属性，评论内容存放在这里
                textarea: '',
                replyTo: {
                    threadId: null, // threadId，表示要回复的目标 thread id
                    rootId: null // 表示要回复的目标 root id
                },
                disableCommit: true,
                emojis: require('@/assets/emoji.json'),
            }
        },
        mounted() {
            // 1. 设置 textarea 为无边框
            //    el-input 实现的 textarea 外层包裹了一个 div，里面才是 textarea 元素，如果强行对 e-input 设置 style 是直接作用最外层
            //    的 div 元素上的。那么如何将样式设置到内部的 textarea 元素上呢？想到一个办法是，通过 query selector 找到 mytextarea
            //    元素，这里获取到的即是 textarea 根元素，将其边框设置为 0。实现方式如下
            var textarea = this.$el.querySelector('#myinput');
            textarea.setAttribute('style', textarea.getAttribute('style')+';border: 0px;');
            // 2. 设置监听 thread reply 事件
            this.$EventBus.$on('reply', (username, threadId, rootId)=>{
                console.log('thread reply:', username, threadId, rootId);
                console.log(this);
                this.handleReply(username, threadId, rootId)
            });
            this.favoriteComponent = this.$parent;
        },
        beforeDestroy() {
            this.$EventBus.$off('reply');
        },
        methods: {
            /**
             * @input 事件的回调方法，每当发生 input 事件，将会回到此方法，主要用来验证当前是否有输入，提交按钮是否生效
             * 1. 如果评论输入区域被置空，则 disable comment commit funcionality
             * 2. 如果评论输入区域被置空，同时将 replyTo 置空，表示用户已经不想 reply 某个 thread 了。
             */
            handleInput() {
                if (this.textarea.trim() != "") {
                    this.disableCommit = false;
                } else {
                    this.disableCommit = true;
                    this.replyTo.threadId = null;
                    this.replyTo.rootId = null;
                }
            },
            /**
             *
             * @param {Number} id, the offset of the emoji
             */
            setEmoji(id) {
                const textAreaEle = document.getElementById("myinput");
                this.textarea = changeSelectedText(textAreaEle, this.emojis[id]);
                // this.textarea += this.emojis[id];
                this.handleInput();
            },
            /**
             * 将评论发送给服务器
             * - 现在每个 thread 的 id 都由一个前缀 comment-，目的是为了让 sliding 能够使用 jquery 精确的找到该 thread。
             */
            submit() {
                console.log('start to commit the comment, content: ', this.textarea, 'reply to:', this.replyTo == null ? 'root' : this.replyTo);
                if (!CachedApiSecurity.isSignedIn()) {
                    console.log('the user has not cached signed in');
                    CachedApiSecurity.handleNoAuthorith();
                } else {
                    // 1. 生成 thread 对象
                    // 模拟实现一个假的 thread 对象
                    // FIXME_, the id should be generated from database
                    // TODO_, 实现添加子评论的动效，这部分就结合后台系统一起联调来实现了。
                    // var _id = Math.floor(Math.random() * 1000000);
                    // console.log('_id: ', _id);
                    // var comment = {
                    //     id: _id,   // the thread id
                    //     root: this.replyTo.rootId === null ? _id: this.replyTo.rootId,  // the first level id.
                    //     username: getCachedUser().username,
                    //     content: this.textarea,
                    //     liked: false, // 自己是否喜欢过？
                    //     likes: 0,
                    //     audit_ts: '12-01-02 06:08',  // 评论发布的日期
                    // }
                    // 异步提交
                    let loading = loadingInstance();
                    this.disableCommit = true;
                    // 记录：不能通过 this.$route.params.shortcode 的方式获取 shortcode，否则获取不到。因此需要从 cache entity 中获取
                    // console.log(`Input, the shortcode ${this.$route.params.shortcode}, the route ${this.$route}, fetch short from parent ${this.$parent.e.shortcode}`);
                    saveComment(this.favoriteComponent.e.shortcode,
                        this.textarea,
                        this.replyTo.threadId !== null ? this.replyTo.threadId.replace(/^comment-/, '') : null,  // parentId
                        this.replyTo.rootId // firstLevelId
                    ).then((thread)=>{
                        console.log('after remove created the comment return:', thread);
                        // 2. append thread
                        this.__appendComment(thread, this.replyTo.threadId, this.replyTo.rootId); // this.replyTo 是通过 infoboard.handleReply 方法赋值的
                        // 3. reset
                        this.__reset();
                        // 4. sliding to the target committed comment
                        // 如果是有子评论但是子评论未加载的时候，添加评论，需要等待子评论渲染成功后才做 sliding 动画。
                        this.__sliding(thread.id);
                    }).catch((error)=>{
                        console.error(error);
                        errorMessage(error.message);
                    }).finally(()=>{
                        loading.close();
                        this.disableCommit = false;
                    });   // firstLevelId
                }
            },

            /**
             * 该方法只是负责将已经保存到数据库中的 comment 根据是 root comment 还是 child comment 的特性添加到页面中。
             *
             * @param comment
             * @param tid
             * @param rootId
             * @private
             */
            __appendComment(comment, tid = null, rootId = null){
                console.log('append comments:', comment, 'tid:', tid, 'rootid:', rootId);
                if(tid == null) {  // add a new root comment
                    this.favoriteComponent.comments.push(comment);
                }else { // reply to the target thread, if target tid is 2nd level then add its to the 1st level
                    var root = this.__findRootComponent(this.favoriteComponent.comments, rootId);
                    if(root.child_comment_count > 0 && (root.threads === undefined || root.threads === null) ){
                        /* 1) 如果 root 有 child comments，并且还没有加载过，那么先要异步远程加载子评论，再追加当前子评论，否则子评论展开后，就只会展示当前子评论 */
                        this.favoriteComponent.$refs.comment.checkReplies(root); // 注意，因为新回复的子评论已保存到服务器了，因此这里直接服务器加载 root child comments 即可。
                    }else{
                        /* 2) 如果 root 没有 child comments 或者 child comments 已经被加载过了，那么直接将用户评论添加上即可，这样做的目的是减少一次数据库的查询 */
                        tid = tid.replace(/^comment-/, ''); // 去掉前缀
                        root.child_comment_count += 1;  // TODO, increase the direct parent child comment count also。目前不需要，因为只针对 root comment 进行评论懒加载。
                        if(root.threads == null){
                            // r.threads = [];
                            Vue.set(root, 'threads', new Array()); // 新增属性 threads 并将其纳入响应式管理！
                        }
                        root.threads.unshift(comment);  // 向数组头部添加。
                    }
                }
            },

            __reset(){
                this.textarea = ""; // reset the input area
                this.replyTo.threadId = null; // reset the reply to
                this.replyTo.rootId = null;
            },

            /**
             * sliding to the target comment.
             * 备注，没有找到原生有效的方式，目前采用的是 jQuery 所提供 滑动效果。
             * @param {Number|String} the target comment id
             */
            __sliding(id){
                // 4. 添加滑动动效，滚动条自动滚动太评论添加处即 Thread 处。
                this.$nextTick(() => {
                    // 试过原生的 scroll to 属性和方法，还是 Jquery scroll to 效果最好的，参考《前端/滚动-如何滚动到指定元素位置.md》
                    var container = $('#comment-panel');
                    var target = $('#comment-' + id);   // 这里就是为什么要使用 comment- 前缀原因了。
                    // 注意，这里返回的是一个数组，因此使用 length 判断。
                    if(target.length === 0) return; // 只有一种情况会为 Null，即 root comment 有子评论但没有加载的时候直接回复，这种情况也无需 sliding，因此略过。

                    // console.log('container scroll top:', container.scrollTop(), // 获取的是 scrollable container 隐藏部分的高度
                    //     'container scroll height:', container[0].scrollHeight, // 获取 scrollable container 的总高度
                    //     'container offset top', container.offset().top,
                    //     'target offset top:', target.offset().top,  // 这里获取的始终是到 HTML 的偏移量，没有太大的参考价值
                    //     'target position top:', target.position().top, // 这里获取的才是相对于 absolute/relative parent node 的偏移量
                    //     'target offset container:', target.offset().top - container.offset().top
                    // );

                    // container.scrollTop(container.scrollTop() + target.position().top);
                    // 参数解析：600 毫秒（滑动的时长）、swing 表示开始和结束的位置慢，中间快。

                    // container.scrollTop() + target.offset().top - container.offset().top 计算得出的是新增评论的精准 scroll
                    // top 值，但是它是顶格展示，对用户体验很不友好，因为看不到自己所回复的内容。因此这里向上再偏移 OFFSET_TOP 个像素。
                    var OFFSET_TOP = -100

                    container.animate(
                        { scrollTop: container.scrollTop() + target.offset().top - container.offset().top + OFFSET_TOP},
                        '600',
                        'swing',
                        function () {
                            // 给新增加的评论增加些许特效！淡出淡入！
                            target.fadeOut('300');
                            target.fadeIn('1500');
                        }
                    );
                });
            },

            __findRootComponent(comments, rootId){
                for(let c of comments){
                    if(c.id === rootId)
                        return c;
                }
                throw new Error(`the root comment w/ ${rootId} not found`);
            },

            /**
             * 处理用户点击 thread 回复按钮的回调事件，用户点击按钮后，发送一个 reply 的全局事件，这里监听并处理。
             */
            handleReply(username, threadId, rootId){
                console.log('handle reply:', username, threadId, rootId);
                this.textarea = "@"+username+" ";  // 清空输入框，并添加 @xxx
                this.replyTo.threadId = threadId; // the thread that reply to
                this.replyTo.rootId = rootId;

                // myinput 是 input element 的 textarea 的 id
                this.$refs.textarea.focus();
            }
        },
    }
</script>

<style scoped>
    .emoji-wrapper {
        display: flex;
        flex-wrap: wrap;
        height: 300px; /* 控制 emoji 弹出的高度 */
        overflow: scroll;
    }

    .emoji-item {
        width: 10%;  /* 这个属性最为关键，控制每个 emoji item 占用的宽度 */
        font-size: 20px; /* emoji 的大小*/
        text-align: center;
        cursor: pointer;
    }

    .emoji-item:hover{
        background-color: lightgray;
    }

</style>



// WEBPACK FOOTER //
// src/components/comments/Input.vue